export default __webpack_public_path__ + "static/media/full-bundle-accuchek-gray@3x.95952c4b.webp";